"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fragmentAcyclicBonds = fragmentAcyclicBonds;
const mf_parser_1 = require("mf-parser");
const openchemlib_utils_1 = require("openchemlib-utils");
/**
 * The function performs the fragmentation of all single linear bonds
 * @param {import('openchemlib').Molecule} molecule - The OCL molecule to be fragmented
 * @param {object} [options={}]
 * @param {boolean} [options.calculateHoseCodes=false] - calculating hose code for bonds is quite time consuming
 * @param {string} [options.parentIDCode=molecule.getIDCode()]
 * @returns Results fragmentation of acyclic bonds
 */
function fragmentAcyclicBonds(molecule, options = {}) {
    const { Molecule } = molecule.getOCL();
    const { calculateHoseCodes, parentIDCode = molecule.getIDCode() } = options;
    let atoms = [];
    // Prepare object with lenght equal to number of atoms
    for (let i = 0; i < molecule.getAllAtoms(); i++) {
        let atom = {};
        atoms.push(atom);
        atom.i = i;
        atom.links = [];
    }
    let bonds = [];
    for (let i = 0; i < molecule.getAllBonds(); i++) {
        let bond = {
            index: i,
            order: molecule.getBondOrder(i),
            atom1: molecule.getBondAtom(0, i),
            atom2: molecule.getBondAtom(1, i),
            type: molecule.getBondType(i),
            isAromatic: molecule.isAromaticBond(i),
            isRingBond: molecule.isRingBond(i),
            selected: false,
        };
        // Mapping of bonds to be fragmented, only if they are single bond not aromatic and cyclic the mapping occurs
        if (bond.isAromatic ||
            bond.type > 1 ||
            bond.isRingBond ||
            bond.order !== 1) {
            continue;
        }
        else {
            bond.selected = true;
            atoms[bond.atom1].links.push(bond.atom2);
            atoms[bond.atom2].links.push(bond.atom1);
        }
        bonds.push(bond);
    }
    let brokenMolecule = {};
    let fragmentMap = [];
    let nbFragments = 0;
    let results = [];
    for (let bond of bonds) {
        if (bond.selected) {
            // if bond.selected is true (line 46) the molecule will be fragmented
            brokenMolecule[bond.index] = molecule.getCompactCopy(); // get a copy of the molecule
            brokenMolecule[bond.index].setAtomCustomLabel(bond.atom1, '*');
            brokenMolecule[bond.index].setAtomCustomLabel(bond.atom2, '*');
            brokenMolecule[bond.index].markBondForDeletion(bond.index); //mark bond to be deleted
            // the function returns an array of map
            brokenMolecule[bond.index].deleteMarkedAtomsAndBonds(); // delete marked bonds
        }
        nbFragments = brokenMolecule[bond.index].getFragmentNumbers(fragmentMap);
        // only if there are 2 fragments code can continue
        if (nbFragments === 2) {
            for (let i = 0; i < nbFragments; i++) {
                const result = {};
                if (calculateHoseCodes) {
                    result.hoses = (0, openchemlib_utils_1.getHoseCodesForAtoms)(molecule, [
                        bond.atom1,
                        bond.atom2,
                    ]);
                }
                result.atomMap = [];
                // assign fragment id to index of for loop
                let includeAtom = fragmentMap.map((id) => {
                    return id === i;
                });
                let fragment = new Molecule(100, 100);
                let atomMap = [];
                brokenMolecule[bond.index].copyMoleculeByAtoms(fragment, includeAtom, false, atomMap);
                for (let j = 0; j < atomMap.length; j++) {
                    if (fragment.getAtomCustomLabel(atomMap[j]) === '*') {
                        result.atomMap.push(j);
                        if (atoms[j].links.length > 0) {
                            fragment.addBond(atomMap[j], fragment.addAtom(154));
                        }
                    }
                }
                fragment.removeAtomCustomLabels();
                fragment.setFragment(false);
                result.idCode = fragment.getIDCode();
                result.parentIDCode = parentIDCode;
                result.cleavedBonds = [
                    {
                        index: bond.index,
                        order: bond.order,
                        atom1: bond.atom1,
                        atom2: bond.atom2,
                    },
                ];
                result.mfInfo = new mf_parser_1.MF((0, openchemlib_utils_1.getMF)(fragment).mf.replace(/R[1-9]?/, '')).getInfo();
                result.fragmentType = 'acyclic';
                results.push(result);
            }
        }
    }
    // sort result in order fragment 1-2; 3-4; ...
    results = results.toSorted((a, b) => {
        return a.mfInfo.monoisotopicMass - b.mfInfo.monoisotopicMass;
    });
    return results;
}
//# sourceMappingURL=fragmentAcyclicBonds.js.map